import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-miles',
  templateUrl: './miles.component.html',
  styleUrls: ['./miles.component.scss'],
  standalone: false
})
export class MilesComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';
  workflowImage = 'assets/images/websitev2/workflow-diagrams/miles-and-score.png';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Key Features', icon: 'bx-star' },
    { id: 'journey', label: 'Rewards Journey', icon: 'bx-map' },
    { id: 'campaigns', label: 'Campaigns', icon: 'bx-trending-up' },
    { id: 'workflow', label: 'Workflow', icon: 'bx-git-branch' },
  ];

  highlights = [
    { icon: 'bx-check-shield', label: 'Behaviour-Based Rewards', desc: 'Miles credited automatically based on safe and responsible driving behaviour detected by VC-SCORE.' },
    { icon: 'bx-pulse', label: 'Real-Time Tracking', desc: 'Drivers see their accumulated miles in real time via the app and dashboard.' },
    { icon: 'bx-gift', label: 'Campaign Crediting', desc: 'OEMs and partners can create campaigns that credit bonus miles for specific driving milestones or events.' },
    { icon: 'bx-store-alt', label: 'V-Store Redemption', desc: 'Miles can be redeemed through the integrated V-Store for partner offers, services, and rewards.' },
    { icon: 'bx-history', label: 'Miles History', desc: 'Full transaction history of earned, spent, and expired miles with detailed breakdowns per trip.' },
    { icon: 'bx-time', label: 'Expiry Management', desc: 'Configurable miles expiry policies with advance notifications to drive redemption behaviour.' },
  ];

  journey = [
    { step: '01', label: 'Drive Safely', desc: 'Driver completes trips while the connected vehicle records telematics data.' },
    { step: '02', label: 'Score Events', desc: 'VC-SCORE processes the trip and assigns a safety score based on detected events.' },
    { step: '03', label: 'Earn Miles', desc: 'Miles are automatically credited to the driver\'s account based on trip score and any active campaigns.' },
    { step: '04', label: 'Redeem Rewards', desc: 'Driver redeems accumulated miles in the V-Store for offers, products, and partner deals.' },
  ];

  campaignTypes = [
    { title: 'Safe Driving Campaigns', desc: 'Reward specific safe driving thresholds like consistent helmet use, zero harsh braking trips, or low-speed zones.' },
    { title: 'Distance Milestones', desc: 'Celebrate and reward drivers reaching distance milestones — first 500 km, monthly distance goals, etc.' },
    { title: 'Seasonal Campaigns', desc: 'Time-limited campaigns tied to festivals, events, or OEM launch periods to boost engagement.' },
    { title: 'Partner Campaigns', desc: 'Brand-sponsored campaigns that credit miles when drivers interact with partner services or locations.' },
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
